import { makeAutoObservable } from 'mobx'
import { uiStore } from 'shared/store/uiStore'
import { logger } from 'shared/lib'
import { ComplianceApi, type IResponseOptInData, EnumOptInMethodTypes } from 'entities/Compliance'
import { type LocalNumbersRoutes } from 'pages/settings/pages/compliance/pages/localNumbers'
import { type LocalNumbersStepsStore } from 'pages/settings/pages/compliance/pages/localNumbers/store/localNumbersStepsStore'
import { SettingsPath } from 'pages/settings/route/settingsPath'

export class OptInMethodStore {
  constructor(private _localNumbersStore: LocalNumbersStepsStore) {
    makeAutoObservable(this)
  }

  private _optInMethods: EnumOptInMethodTypes[] = []

  get optInMethods() {
    return this._optInMethods
  }

  get isStep3Disabled() {
    return !this.optInMethods.length
  }

  get localNumbersStore() {
    return this._localNumbersStore
  }

  init = (optInData: IResponseOptInData[] | null) => {
    if (!optInData) return

    const optInMethods = optInData.map((item) => item.optInMethod)
    this.setOptInMethodsInStrictOrder(optInMethods)
  }

  campaignOptInMethodNextClick = async (path: LocalNumbersRoutes) => {
    if (!this.localNumbersStore.campaignId) return
    try {
      this.localNumbersStore.stepsStore.setStepLoading(true)

      const { data } = await ComplianceApi.updateComplianceServicesCampaign({
        step: 3,
        campaignId: this.localNumbersStore.campaignId,
        optInMethods: this.optInMethods,
      })

      const step = this.localNumbersStore.getNextStep(path)
      this.localNumbersStore.complianceLayerStore.set10DLCServiceCampaign(data)

      uiStore.changeRoute({
        path: `/${SettingsPath.compliance.localNumbers.root}/${step}`,
      })
    } catch (e) {
      logger.error(e)
    } finally {
      this._localNumbersStore.stepsStore.setStepLoading(false)
    }
  }

  setOptInMethods = (value: EnumOptInMethodTypes) => {
    let optInMethods: EnumOptInMethodTypes[]

    this.optInMethods.includes(value)
      ? (optInMethods = this.optInMethods.filter((item) => item !== value))
      : (optInMethods = [...this.optInMethods, value])

    this.setOptInMethodsInStrictOrder(optInMethods)
  }

  setOptInMethodsInStrictOrder(array: EnumOptInMethodTypes[]) {
    const order = Object.values(EnumOptInMethodTypes)

    this._optInMethods = array.sort((a, b) => order.indexOf(a) - order.indexOf(b))
  }

  isOptInMethodActive = (value: EnumOptInMethodTypes) => this.optInMethods.includes(value)
}
